import { useEffect, useRef } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import BrowserLogger from 'alife-logger';
// 导入你的路由配置，作为唯一的“数据源”
import routerConfig from '@/router/index';

// 提前将路由列表提取出来
const { routes } = routerConfig;

/**
 * 动态地从路由配置中查找匹配的页面名称
 * @param {string} pathname - 当前的URL路径, e.g., "/orderPay/m123/s456"
 * @returns {string} - 匹配到的路由模式, e.g., "/orderPay/:orderNumber/:salesNumber"
 */
function getPageNameFromRoutes(pathname) {
    // 遍历你的路由配置列表
    const matchedRoute = routes.find((route) => {
        // 使用 react-router-dom v5 的 matchPath 语法
        const match = matchPath(pathname, {
            path: route.path,
            exact: route.exact, // 你的配置里有 exact，所以这里要加上
            strict: false, // 通常设置为false，除非你有特殊需求
        });
        return match !== null;
    });

    // 如果找到了匹配的路由
    if (matchedRoute) {
        return matchedRoute.path;
    }
    // 如果依然没有匹配，打印一个警告，帮助调试
    console.log(`[ARMS Tracker] No match found for pathname: "${pathname}" in router config.`);
    return pathname;
}


/**
 * 阿里云前端监控PV上报的自定义Hook (现在是动态版本)
 */
const useAliyunPageTracker = () => {
    const location = useLocation();
    // 使用useRef来持久化保存SDK实例和上一个路径
    const trackerRef = useRef(null);
    const lastPathname = useRef(null);

    // 这个Effect负责初始化SDK，并处理所有的PV上报
    useEffect(() => {
        // 步骤1: 如果SDK实例还未创建，则在首次运行时创建它
        try{
            if (!trackerRef.current) {
                const __bl = BrowserLogger.singleton({
                    environment:window.env == 'prod' ? 'prod' : 'daily',
                    pid:"j85n1wxbhl@be3081fca594ac9",
                    appType:"web",
                    imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",
                    sendResource:true,
                    enableApiCors:true,
                    enableLinkTrace:true,
                    behavior:true,
                    enableConsole:true,
                    enableSPA:false,
                    autoSendPv:false
                });
                trackerRef.current = __bl; // 将实例存入ref中
            }
            // 步骤2: 检查是否是真实的路径变化（忽略仅hash的改变）
            if (location.pathname !== lastPathname.current) {
                lastPathname.current = location.pathname; // 更新最后访问的路径

                const pageName = getPageNameFromRoutes(location.pathname);
                trackerRef.current.setPage(pageName, true);
            }
        }catch (e){
            console.log('前端页面监控失败',e)
        }

    }, [location]); // 依赖项是location，确保路由变化时重新运行

    return null; // 此Hook不渲染任何UI
};

export default useAliyunPageTracker;
